export const POST_FORGOT_PASSWORD = 'POST_FORGOT_PASSWORD';
export const POST_FORGOT_PASSWORD_ERRORS = 'POST_FORGOT_PASSWORD_ERRORS';

export const forgotPassword = (params) => {
  return {
    type: POST_FORGOT_PASSWORD,
    params,
  };
};
